import React, { useEffect, useRef } from "react";
// styled components
import { Button, Modal, Form, Input, Select } from "antd";
// hooks

// models
import {
  DocumentosTecnicosModel,
  initialValuesDocumentosTecnicosModel,
} from "../../../../../models/DocumentosModel/documentosTecnicos.model";
import { saveFile } from "../../../../../utils/saveFile";
import { useMaestras } from "../../../../../hooks/useMaestras";
import DocumentInput from "../../../../../utils/DocumentInput";
import { openNotification } from "../../../../../utils/Notifactions";

interface IProps {
  visualizar: boolean;
  setVisualizar: any;
  documento: DocumentosTecnicosModel;
  setDocumento: any;
  documentos: Array<DocumentosTecnicosModel>;
  setDocumentos: any;
  indexdocumento: number;
}

export const ModalEditarDocumentosTecnicos: React.FC<IProps> = (props: IProps) => {
  const fileInputRef = useRef<any>(null);

  const { documentosTecnicos, obtenerDocTec } = useMaestras();

  //   efects
  useEffect(() => {
    obtenerDocTec();
  }, []);


  //  functions
  const editarFila = () => {
    let infoupdate = [...props.documentos];
    infoupdate[props.indexdocumento] = props.documento;
    props.setDocumento(initialValuesDocumentosTecnicosModel);
    props.setVisualizar(false);
    return props.setDocumentos(infoupdate);
  };
  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      let archivo = e.target.files[0];

      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      await saveFile(e);
      if (
        archivo.type === "application/pdf" ||
        archivo.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        archivo.type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document" ||
        archivo.type === "image/png" ||
        archivo.type === "image/jpeg"
      ) {
        let infoupdate = [...props.documentos];
        infoupdate[props.indexdocumento].url_documento = archivo.name;
        props.documento.url_documento = archivo.name;
        return props.setDocumentos(infoupdate);
      }
    }
  };
  // fields
  const fields = [
    { name: "tipo_documento", value: props.documento.tipo_documento },
    { name: "descripcion", value: props.documento.descripcion },
    { name: "url_documento", value: props.documento.url_documento },
  ];
  return (
    <Modal
      className="ant-modal-close-x2"
      title="Editar documentación técnica"
      visible={props.visualizar}
      onCancel={() => {
        props.setDocumento(initialValuesDocumentosTecnicosModel);
        props.setVisualizar(false);
      }}
      width={1200}
      footer={[
        <Button key="b_cerrar_modal_docu_tecn"
          className="button-gray-ghost"
          onClick={() => {
            props.setDocumento(initialValuesDocumentosTecnicosModel);
            props.setVisualizar(false);
          }}
        >
          Cerrar
        </Button>,
        <Button key="b_guardar_modal_docu_tecn"
          className="button-azul-radius"
          htmlType="submit"
          form="documentosconvocatoriaeditardocumentostecnicosconvocatoria"
        >
          Guardar
        </Button>,
      ]}
      cancelButtonProps={{ style: { display: "none" } }}
    >
      <div className="container-fluid">
        <div className="row">
          <Form
            name="documentosconvocatoriaeditardocumentostecnicosconvocatoria"
            size="large"
            layout="vertical"
            className="col-12"
            onFinish={() => {
              editarFila();
            }}
            fields={fields}
            onFieldsChange={(_, fields: any) => {
              let infoupdate: any = { ...props.documento };
              for (const i in fields) {
                infoupdate[fields[i].name] = fields[i].value;
              }
              props.setDocumento(infoupdate);
            }}
          >
            <div className="row">
              <div className="col-12 col-md-6">
                <Form.Item
                  className="no-margin"
                  label="Requisito"
                  name="tipo_documento"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Select placeholder="Seleccionar..">
                    {documentosTecnicos.map(({ id, nombre }: any) => (
                      <Select.Option key={id} value={nombre}>
                        {nombre}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </div>
              <div className="col-12 col-md-6">
                <span className="font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-535353 mt-1">
                  Adjuntar un archivo
                </span>
                <DocumentInput
                  doc={props.documento.url_documento}
                  fileInputRef={fileInputRef}
                  tipos_doc="PDF, DOCX, XLSX, JPG, PNG."
                  on_change={(e) => {
                    guardarArchivo(e);
                    e.target.value = "";
                  }}
                  onDelete={() => props.setDocumento({ ...props.documento, url_documento: "" })}
                />
              </div>
              <div className="col-12">
                <Form.Item

                  label="Descripción"
                  name="descripcion"
                  rules={[{ required: true, message: "Campo obligatorio" }]}
                >
                  <Input.TextArea showCount={true} maxLength={300} />
                </Form.Item>
              </div>

            </div>
          </Form>
        </div>
      </div>
    </Modal>
  );
};
